import { render, staticRenderFns } from "./ImmoCarouselOffer.vue?vue&type=template&id=6436abee&scoped=true&"
import script from "./ImmoCarouselOffer.vue?vue&type=script&lang=js&"
export * from "./ImmoCarouselOffer.vue?vue&type=script&lang=js&"
import style0 from "./ImmoCarouselOffer.vue?vue&type=style&index=0&id=6436abee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436abee",
  null
  
)

export default component.exports